import { render } from "./SubscriptionsPage.vue?vue&type=template&id=51c05792"
import script from "./SubscriptionsPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionsPage.vue?vue&type=script&lang=js"

import "./SubscriptionsPage.vue?vue&type=style&index=0&id=51c05792&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__